module.exports = __webpack_public_path__ + "static/media/imft_logo.800ef709.png";